export default function rainCode(cvs){
	
	//const cvs = document.querySelector("canvas");
	console.log(cvs);
	function cvsInit() {
	  cvs.width = window.innerWidth;
	  cvs.height = window.innerHeight;
	  cvs.style.backgroundColor = "#000";
	}
	
	// 初始化canvas
	cvsInit();
	const ctx = cvs.getContext("2d");
	
	//文字大小
	const fontSize = 20;
	// 总列数
	const columnsCount = Math.floor(cvs.width / fontSize);
	// 每列的索引
	const columnsIndex = new Array(columnsCount).fill(0);
	
	// 获取随机字符串
	function getRandomChar() {
		const str = "长沙永芸有课丫";
		const index = Math.floor(Math.random() * str.length)
		return str.slice(index,index+1);
	  // const charCode = Math.floor(Math.random() * 26) + 65;
	  // return String.fromCharCode(charCode);
	}
	
	// 获取随机颜色
	function getRandomColor() {
	  let result = (Math.random() * 0xffffff).toString(16);
	  return "#" + result.slice(0, 6);
	}
	
		
	function draw() {

	  // 画一层透明的布
	  ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
	  ctx.fillRect(0, 0, cvs.width, cvs.height);
	
	
	  ctx.font = fontSize + "px Arial";
	
	  for (let i = 0; i < columnsCount; i++) {
	    ctx.fillStyle = getRandomColor();
	    const index = columnsIndex[i];
	    const x = i * fontSize;
	    const y = index * fontSize;
	
	    ctx.fillText(getRandomChar(), x, y);
	
	    if (y > cvs.height && Math.random() > 0.99) {
	      columnsIndex[i] = 0;
	    } else {
	      columnsIndex[i]++;
	    }
	  }
	}
	
	setInterval(draw, 30);

}
